import React, {useState} from 'react'
import {FilterText, Title} from "../Styles";
import {Slider, Radio, Button} from "antd";
import {entrieslList} from "../../Core/Actions/EntriesList";
import {useDispatch, useSelector} from "react-redux";
import {colors} from "../../Constants/Constants";
import {layoutGenerator} from "react-break";

const screen = layoutGenerator({
    mobile: 0,
    tablet: 768,
    desktop: 992,
});
const OnAtLeastTablet = screen.isAtLeast('tablet');

const Filters = ({onPlacesClicked, showTooltip}) => {
    const [price, setPrice] = useState([20000, 75000])
    const [area, setArea] = useState([20, 180]);
    const [day, setDay] = useState(2);
    const [time, setTime] = useState(0);
    const dispatch = useDispatch();
    const loading = useSelector(state => state.entries.loading)

    const onFilterChange = () => {
        if (price !== 0 || area !== 0 || time !== 0 ) {
            onPlacesClicked([]);
            dispatch(entrieslList(price, area, time))
        }

    }
    const handlePrice = (value) => {
        if (value[1] >= 80000) {
            setPrice([value[0], 200000])
        } else {
            setPrice(value)
        }
    }
    const handleArea = value => {
        setArea(value)
    }

    const onDayChange = e => {
        const oneDayToMilliseconds = 24*60*60*1000
        const today = Date.now()-oneDayToMilliseconds;
        const oneWeek = Date.now()-(oneDayToMilliseconds * 7);
        const twoWeeks = Date.now()-(oneDayToMilliseconds * 14);

        setDay(e.target.value);
        if (e.target.value === 1) {
            setTime(today);
        } else if (e.target.value === 2) {
            setTime(oneWeek)
        } else if (e.target.value === 3) {
            setTime(twoWeeks)
        }
    }

     const onSliderChange = (e) => {

        if(e >= 80000) {
            return '+'
        } else {
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'Lek', minimumFractionDigits: 0 }).format(e);
        }
     }

     const areaTooltip = (e) => {
        return e + ' '+ "\t\u33A1";
     };
    return (
        <div style={{marginTop: '32px'}}>
            <OnAtLeastTablet>
                <Title style={{color: colors.darkOrange, fontSize: '40px'}}>
                    Shtepia+
                </Title>
            </OnAtLeastTablet>
            <FilterText>Day</FilterText>
            <Radio.Group onChange={onDayChange} value={day}>
                <Radio value={1}>Today</Radio>
                <Radio value={2}>7 days</Radio>
                <Radio value={3}>14 days</Radio>
            </Radio.Group>
            <FilterText>Price</FilterText>
            <Slider  tooltipVisible={showTooltip}  range defaultValue={price} step={5000} min={20000} max={80000} tipFormatter={onSliderChange} onChange={handlePrice}
                    railStyle={{background: colors.darkOrange}} style={{width: '80%'}}/>
            <FilterText>Area</FilterText>
            <Slider tooltipVisible={showTooltip} range defaultValue={area} min={20} max={180} step={10} tipFormatter={areaTooltip} onChange={handleArea}
                    railStyle={{background: colors.darkOrange}} style={{width: '80%'}}/>
            <Button type="primary" shape="round"
                    style={{width: '50%', backgroundColor: colors.darkOrange, borderColor: colors.darkOrange}}
                    loading={loading} onClick={onFilterChange}>Apply</Button>
        </div>
    );
};

export default Filters;